import TextField from "@/common/components/TextField";

export type BranchInformationProps = {
  displayName?: string;
  parentId?: string;
  parentDisplayName?: string;
};

export const BranchInformation = ({
  displayName,
  parentId,
  parentDisplayName,
}: BranchInformationProps) => {
  return (
    <div className="flex gap-2 w-full justify-between">
      <TextField
        name="display_name"
        label="Nome da filial"
        value={displayName}
        className="w-full"
        disabled
      />
      {parentId && (
        <TextField
          name="parent"
          label="Filial Mãe"
          className="w-full"
          value={parentDisplayName}
          disabled
        />
      )}
    </div>
  );
};
